<template>
  <div class="left-menu">
    <div class="logo-con">
      <i class="el-icon-s-goods"></i>
    </div>
    <ul class="ul">
      <li :class="[current == 'index' ? 'current' : '']" @click="redirect('/')">
        <i class="el-icon-stopwatch"></i>
        <a>Home</a>
      </li>
      <!-- <li
        :class="[current == 'diy' ? 'current' : '']"
        @click="redirect('/diy')"
      >
        <i class="el-icon-sell"></i>
        <a>建模</a>
      </li>
      <li
        :class="[current == 'goods' ? 'current' : '']"
        @click="redirect('/goods')"
      >
        <i class="el-icon-collection"></i>
        <a>商品</a>
      </li> -->
      <li
        :class="[current == 'orders' ? 'current' : '']"
        @click="redirect('/orders')"
      >
        <div class="h3-div-left">
          <i class="el-icon-tickets"></i>
          <a>Orders</a>
        </div>
        <ul class="sub-list-ul">
          <!-- <li @click="redirect('/orders/visitor')" :class="[active == 'visitor' ? 'active' : '']"><a>访客</a></li> -->
          <!-- <li @click="redirect('/orders/customer')" :class="[active == 'customer' ? 'active' : '']"><a>客户</a></li> -->
          <!-- <li @click="redirect('/orders/diy-create')" :class="[active == 'diy' ? 'active' : '']"><a>作品</a></li> -->
          <!-- <li @click="redirect('/orders/submit')" :class="[active == 'submit' ? 'active' : '']"><a>提交</a></li> -->
          <!-- <li @click="redirect('/orders/cart')" :class="[active == 'cart' ? 'active' : '']"><a>加购</a></li> -->
          <!-- <li @click="redirect('/orders/abandoned')" :class="[active == 'abandoned' ? 'active' : '']"><a>弃单</a></li> -->
          <li @click="redirect('/orders')" :class="[current == 'orders' ? 'active' : '']"><a>Orders</a></li>
          <li @click="redirect('/returns')" :class="[current == 'returns' ? 'active' : '']"><a>Returns</a></li>
        </ul>
      </li>
      <li
        :class="[current == 'factory' ? 'current' : '']"
        @click="redirect('/factory')"
      >
        <i class="el-icon-cherry"></i>
        <a>Factory</a>
      </li>
      <li
        v-if="uid === 1"
        :class="[current == 'email' ? 'current' : '']"
        @click="redirect('/email')"
      >
        <i class="el-icon-eleme"></i>
        <a>Email</a>
      </li>
      <!-- <li
        :class="[current == 'logistics' ? 'current' : '']"
        @click="redirect('/logistics')"
      >
        <i class="el-icon-truck"></i>
        <a>logistics</a>
      </li> -->
      <!-- <li
        :class="[current == 'users' ? 'current' : '']"
        @click="redirect('/users')"
      >
        <i class="el-icon-user"></i>
        <a>用户</a>
      </li> -->
      <li
        v-if="uid === 1"
        :class="[current == 'setting' ? 'current' : '']"
        @click="redirect('/setting')"
      >
        <i class="el-icon-setting"></i>
        <a>setting</a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: ["current","active"],
  computed: {
    is_root() { 
      var apps_options = this.$store.state.public.cfg.apps_options
      for (var i = 0; i < apps_options.length; i++) {
        if (apps_options[i].label == 'casedrawing') {
          return true
        }
      }
      return false
    }
  },
  data() { 
    return {
      uid:0,
    }
  },
  mounted() { 
    var admin_password = this.getCookie("admin_password");
    if (admin_password === 'b1315E8') {
      this.uid = parseInt(localStorage.getItem("uid"));
    }
  },
};
</script>
<style scoped>
.left-menu {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: 111px;
  background: #333;
  color: #efefef;
  z-index: 11;
}
.left-menu .logo-con {
  height: 44px;
  text-align: center;
  border-bottom: 1px solid #666;
  box-sizing: border-box;
  padding-top: 10px;
}
.left-menu .logo-con .el-icon-s-goods {
  font-size: 20px;
}
.left-menu .ul > li {
  text-align: left;
  padding: 10px;
  box-sizing: border-box;
  cursor: pointer;
}
.left-menu .ul > li:active,
.left-menu .ul > li.current {
  background: #000;
  color: #fff;
}
.left-menu .ul > li a {
  color: #efefef;
  font-size: 12px;
}
.left-menu .sub-list-ul{margin-left: 10px;margin-top: 10px;}
.left-menu .sub-list-ul li{padding: 5px;box-sizing: border-box;color: gray;}
.left-menu .sub-list-ul li a{color: gray;}
.left-menu .sub-list-ul li.active a{color: #efefef;}
</style>



// WEBPACK FOOTER //
// src/pages/public/_left.vue